import React from 'react'
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

import { SelectInput } from '../Inputs'

const styles = {
    item : {
        display: 'flex',
        alignItems: 'center',
    },
    icon : {
        backgroundSize: 'cover',
        width: 20,
        height: 20,
        display: 'inline-block',
        marginRight : 5,
    },
    iconAprobado : { backgroundImage: 'url("/images/parametro_aprobado_small.png")' },
    iconEnUso : { backgroundImage: 'url("/images/parametro_en_uso_small.png")' },
    iconRechazado : { backgroundImage: 'url("/images/parametro_rechazado_small.png")' },
}

export const CertificationSelectInput = withStyles(styles)(({ classes, ...props }) => (
    <SelectInput {...props}>
        <MenuItem value={"No Revisado"}>{"No Revisado"}</MenuItem>
        <MenuItem value={"Validado"}>
            <div className={classes.item}>
                <i className={classnames(classes.icon, classes.iconAprobado)}></i>
                <span>{"Validado"}</span>
            </div>
        </MenuItem>
        <MenuItem value={"En Uso"}>
            <div className={classes.item}>
                <i className={classnames(classes.icon, classes.iconEnUso)}></i>
                <span>{"En Uso"}</span>
            </div>
        </MenuItem>
        <MenuItem value={"Rechazado"}>
            <div className={classes.item}>
                <i className={classnames(classes.icon, classes.iconRechazado)}></i>
                <span>{"Rechazado"}</span>
            </div>
        </MenuItem>
    </SelectInput>
))
